import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useOpenableControls } from '../../../generic-hooks'
import { RedPointsBenefitDialog } from '../../../redpoints'
import { ProductBadge } from '../ProductBadge'

interface ProductRedPointsBadgeProps {
  className?: string
  redPointsAmount: number
}

const formattedRedpointsAmount = (amount: number): string => `+${amount}`

export const ProductRedPointsBadge: FC<ProductRedPointsBadgeProps> = ({
  className,
  redPointsAmount,
}) => {
  const modalControls = useOpenableControls()

  return (
    <>
      <ProductBadge
        className={clsx(
          'relative -mb-4 bg-light-brand-medium text-m',
          className,
        )}
        data-qa-id="form-RedPoints-modal"
        onClick={modalControls.handleOpen}
        slots={{ root: 'button' }}
        type="button"
      >
        {formattedRedpointsAmount(redPointsAmount)}
        <span className="block text-xs">
          <FormattedMessage id="general.label.redPoints" />
        </span>
      </ProductBadge>
      <RedPointsBenefitDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
